import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DropdownMenu, Icon, getInputContainerStyles, tokens } from '@hotjar/hotsauce';

const SelectContainer = styled.button<Parameters<typeof getInputContainerStyles>[0]>`
  ${getInputContainerStyles}
  cursor: pointer;
  display: flex;
  align-items: center;
  height: ${tokens.spacer.x5};
  padding: 0 ${tokens.spacer.x2};

  border: none;
  ${tokens.transition()};
  ${tokens.elevation(1)}, inset 0 0 0 1px ${tokens.color.neutral_300};

  :hover {
    ${tokens.elevation(1)}, inset 0 0 0 1px ${tokens.color.neutral_500};
  }

  :focus {
    ${`${tokens.focus()}, inset 0 0 0 1px ${tokens.color.cobalt_800}`};
  }

  :focus-visible {
    outline: none;
  }
`;

const CaretIcon = styled(Icon)`
  flex-shrink: 0;
`;

const SelectLabel = styled.div`
  width: 100%;
  overflow: hidden;
`;

interface AdvancedSelectProps {
  children: JSX.Element[];
  selectContent: JSX.Element;
  id?: string;
  ariaLabel?: string;
  size: 's' | 'm' | 'l';
  maxWidth?: number;
  zIndex?: number;
}

export const AdvancedSelect = ({
  children,
  selectContent,
  id,
  ariaLabel,
  size,
  maxWidth,
  zIndex,
}: AdvancedSelectProps): JSX.Element => {
  return (
    <DropdownMenu
      size={size}
      zIndex={zIndex}
      trigger={
        <SelectContainer
          id={id}
          aria-label={ariaLabel}
          role="combobox"
          isInvalid={false}
          isDisabled={false}
          isReadonly={false}
          tabIndex={0}
          type="button"
          css={css`
            max-width: ${maxWidth}px;
          `}
        >
          <SelectLabel>{selectContent}</SelectLabel>
          <CaretIcon icon="caret_down_alt" color="text_light" />
        </SelectContainer>
      }
    >
      {children}
    </DropdownMenu>
  );
};
